import { useMutation } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

type DismissUnmatchedAlertMutation = {
  listId: string;
};

export const useDismissUnmatchedAlert = () => {
  const { apiClient } = useSalesyApiClient();

  const mutation = useMutation({
    mutationFn: (requestBody: DismissUnmatchedAlertMutation) =>
      apiClient.lists.dismissUnmatchedItemsNotice({
        id: requestBody.listId,
      }),
  });

  const { mutate, ...mutationResult } = mutation;

  return {
    ...mutationResult,
    dismissUnmatchedAlert: mutate,
  };
};
